// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GclU","name":"styles_name__2_X07","phone":"styles_phone__cQh3X"};